/// <amd-module name="VSSUI/Components/HubHeader/HubTileRegion" />

import * as React from "react";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";

import "VSS/LoaderPlugins/Css!VSSUI/Components/HubHeader/HubTileRegion";

/**
 * Component that contains hub tiles to be displayed in the PivotBar.
 */
/** @deprecated */
export class HubTileRegion extends BaseComponent<{}> {
    public render(): JSX.Element {
        const className = css("vss-HubTileRegion");
        const propsChildren = React.Children.toArray(this.props.children as React.ReactNode);
        const children = React.Children.map(propsChildren || [], (item: any, index: number) => {
            const originalChild = item as React.ReactElement<any>;
            const originalProps = originalChild.props;
            const originalClassName = originalProps && originalProps.className;
            const clonedElementProps = {
                ...originalProps,
                className: originalClassName ? originalClassName + " vss-HubTile" : "vss-HubTile"
            };
            return React.cloneElement(item as React.ReactElement<any>, clonedElementProps);
        });

        return <div className={className}>{children}</div>;
    }
}
